class ProductsSlider{

    constructor(el){
        this.el = el;
        this.$el = jQuery(el);
        this.$slider = jQuery('.products-slider-slides', this.el);
        const sliderOptions = JSON.parse(this.el.getAttribute('data-product-slider-options') || '{}');

        //set here default options for slick  - they'll be overridden with specified in fields.
        const defaultSlick = {
            lazyLoad: 'progressive',
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        //dots: true
                    }

                }, {

                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        //dots: true
                    }

                }, {

                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                    }

                }]
        };

        // we merge these via destructuring ...
        this.defaultSlickOptions = {
            ... defaultSlick,
            ... sliderOptions
        };

        this.$slider.slick(this.defaultSlickOptions);

    }


    // randomizeHandles() {
    //     for (let i = this.handles.length - 1; i > 0; i--) {
    //         const j = Math.floor(Math.random() * (i + 1));
    //         [this.handles[i], this.handles[j]] = [this.handles[j], this.handles[i]];
    //     }
    // }

    static initializeStatic() {

        jQuery('.products-slider').each((index, el) => {
            const blockId = `wpshopify_initial_ProductsSlider_${index}`;
            window.WPShopify.blockInstances[blockId] = {
                el: el,
                id: blockId,
                blockInitFunctionName: 'ProductsSlider',
                instance: ProductsSlider.initializeBlock(el)
            };
        });
    }

    static initializeBlock(el){
        return new ProductsSlider(el);
    }

}

ProductsSlider.initializeStatic();
